import React from "react";
import { ArrowRight, Phone, ShieldCheck, Clock, MapPin } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const HERO_IMG =
  "https://images.unsplash.com/photo-1517581177682-a085bb7ffb15?auto=format&fit=crop&w=2000&q=80";

export const Hero = () => {
  const { t } = useLanguage();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMG}
          alt="Worker on a ladder painting an interior room"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/55 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-28 lg:pt-36 lg:pb-40">
        <div className="max-w-3xl fade-up">
          <span className="inline-block text-[11px] uppercase tracking-[0.25em] font-bold text-[#E8D6C2]">
            {t.hero.overline}
          </span>
          <h1
            data-testid="hero-title"
            className="mt-6 font-display text-white text-4xl sm:text-5xl lg:text-7xl tracking-tighter font-medium leading-[1.02]"
          >
            <span className="block">{t.hero.title1}</span>
            <span className="block">{t.hero.title2}</span>
          </h1>
          <p className="mt-8 text-base sm:text-lg text-white/85 leading-relaxed max-w-xl">
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a
              href="#quote"
              data-testid="hero-quote-cta"
              className="inline-flex items-center justify-center gap-2 bg-[#C05C3F] hover:bg-[#a94c32] text-white font-medium px-7 py-4 text-base transition-colors rounded-none"
            >
              {t.hero.cta1}
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="tel:+14388743855"
              data-testid="hero-call-cta"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white backdrop-blur border border-white/25 font-medium px-7 py-4 text-base transition-colors rounded-none"
            >
              <Phone className="h-4 w-4" />
              {t.hero.cta2}
            </a>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-sm text-white/80">
            <span className="inline-flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-[#E8A58B]" />
              {t.hero.badge1}
            </span>
            <span className="inline-flex items-center gap-2">
              <Clock className="h-4 w-4 text-[#E8A58B]" />
              {t.hero.badge2}
            </span>
            <span className="inline-flex items-center gap-2">
              <MapPin className="h-4 w-4 text-[#E8A58B]" />
              {t.hero.badge3}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
